import CircularProgress, {CircularProgressProps} from '@mui/material/CircularProgress';

export const Loader = (props: CircularProgressProps) => {
    return <CircularProgress {...props} />
}